var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgCheck = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 14L6.36907 14.7143C6.59538 15.0198 6.95311 15.2 7.33333 15.2C7.71356 15.2 8.07128 15.0198 8.2976 14.7143L7.33333 14ZM4.96427 8.78572C4.56978 8.25317 3.81828 8.14125 3.28572 8.53573C2.75317 8.93021 2.64125 9.68172 3.03573 10.2143L4.96427 8.78572ZM14.9643 5.71427C15.3588 5.18172 15.2468 4.43021 14.7143 4.03573C14.1817 3.64125 13.4302 3.75318 13.0357 4.28573L14.9643 5.71427ZM8.2976 13.2857L4.96427 8.78572L3.03573 10.2143L6.36907 14.7143L8.2976 13.2857ZM13.0357 4.28573L6.36907 13.2857L8.2976 14.7143L14.9643 5.71427L13.0357 4.28573Z",
    fill: "currentColor"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgCheck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/check.0fa0ce308de03ccb11dd175b50bf296a.svg";